import React from "react"
import {Box} from "@mui/material"

import type {IdentificationHint} from "../types"

import {HintChip} from "./chips"

function HintChips({hints}: {hints: IdentificationHint[]}) {
	if (hints.length === 0) return null

	return (
		<Box display="flex" gap={0.75} flexWrap="wrap">
			{hints.map((hint) => (
				<HintChip key={`${hint.Kind}:${hint.Label}`} hint={hint} />
			))}
		</Box>
	)
}

export {HintChips}
